import React from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';

import { FormGroup, Label } from 'reactstrap';

import { setUserSetting, updateUserSettings } from '../../actions/Auth';

import { getCurrentUser } from '../../helpers/Auth';
import { userHasFeature } from '../../helpers/Features';

const FileMetadataGroupPicker = ({
  metadataGroupToDisplay,
  metadataGroups,
  uploadModal,
  handleMetadataGroupChange,
  selectedFiles,
}) => {
  const intl = useIntl();

  const shouldBeEmpty = !selectedFiles.every(
    (file, _, arr) => file.metadata_group === arr[0].metadata_group,
  );

  const optionsMetadata = metadataGroups.map((tg) => (
    {
      value: `${tg.id}`,
      label: tg.name,
    }));

  const options = [...optionsMetadata,
    {
      value: null,
      label: intl.formatMessage({ defaultMessage: 'No Metadata Group assigned' }),
    },
  ];

  const selectedOption = options
    .find(o => o.value === metadataGroupToDisplay) || options.find(o => o.value === null);

  if (metadataGroups.length === 0) return null;

  return (
    <FormGroup
      className="metadata-group-box"
    >
      <Label
        for="selectMetadataGroup"
      >
        <i className="far fa-folder-open" />{intl.formatMessage({ defaultMessage: 'Metadata Group' })}
      </Label>
      <Select
        id="metadata-group-list"
        classNamePrefix="metadata-group-select"
        isMulti={false}
        isSearchable={true}
        isDisabled={(!userHasFeature('custom-categories'))}
        placeholder=""
        filterOption={false}
        onInputChange={() => { }}
        onChange={handleMetadataGroupChange}
        value={shouldBeEmpty ? null : selectedOption}
        options={options}
        getOptionValue={option => option.value}
        getOptionLabel={option => option.label}
        onMenuOpen={() => {}}
        onMenuClose={() => {}}
        menuPortalTarget={uploadModal ? undefined : document.querySelector('.file-modal')}
        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      />
    </FormGroup>
  );
};

const mapStateToProps = state => ({
  taxonomies: state.Metadata.taxonomies,
  metadataGroups: state.Metadata.metadataGroups,
  uploadModal: state.Files.uploadModal,
});

const mapDispatchToProps = (dispatch) => ({
  handleUserSetting: (setting) => {
    const profile = getCurrentUser();
    if (profile) {
      dispatch(setUserSetting(setting));
      dispatch(updateUserSettings(profile.uuid, setting));
    }
  },
});

FileMetadataGroupPicker.propTypes = {
  metadataGroupToDisplay: PropTypes.string,
  uploadModal: PropTypes.bool.isRequired,
  metadataGroups: PropTypes.array.isRequired,
  selectedFiles: PropTypes.array.isRequired,
  handleMetadataGroupChange: PropTypes.func.isRequired,
};

FileMetadataGroupPicker.defaultProps = {
  metadataGroupToDisplay: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(FileMetadataGroupPicker);
